import type { ConversationRowEdge, MailboxInfo, ConversationType as Schema_ConversationType, } from "owa-graph-schema";
import type { ConversationTableType } from "owa-offline-conversations-schema";
import { mapOwsConversationTypeToGql } from "../mapOwsConversationTypeToGql";
import type ConversationType from "owa-service/lib/contract/ConversationType";

export function getStartCursor(conversations?: any[]): string {
    if (conversations && conversations.length > 0) {
        return conversations[0].InstanceKey ?? "";
    }
    
    return "";
}

export function getEndCursor(conversations?: any[]): string {
    if (conversations && conversations.length > 0) {
        return conversations[conversations.length - 1].InstanceKey ?? "";
    }
    
    return "";
}

export function getEdges(mailboxInfo: MailboxInfo, conversations?: ConversationTableType[] | ConversationType[], folderId?: string): ConversationRowEdge[] {
    if (!conversations || conversations.length == 0) {
        return [];
    }
    
    return conversations.map(conversation => {
        return {
            __typename: "ConversationRowEdge",
            cursor: conversation.InstanceKey ?? "",
            node: isConversationTableType(conversation)
                ? (conversation as Schema_ConversationType)
                : mapOwsConversationTypeToGql(conversation, mailboxInfo, folderId),
        } as ConversationRowEdge;
    });
}

function isConversationTableType(conversation: ConversationTableType | ConversationType): conversation is ConversationTableType {
    return (conversation as ConversationTableType).MetaData !== undefined;
}
